import Newsletter from '@/components/Newsletter'

export function init () {
  const newsletterBlock = document.querySelector('.footer-newsletter')
  const newsletterPopup = document.querySelector('footer #modal-newsletter-signin')
  const component = new Newsletter(newsletterBlock, newsletterPopup)
  component.initNewsletter()  
}


// WEBPACK FOOTER //
// ./src/modules/newsletter.js